import { useState } from 'react';

import { useQueryParams } from './useQueryParams';

export const useTableState = (initialSortBy, initialSortOrder = 'asc') => {
  const { queryParams, setQueryParams } = useQueryParams();
  const {
    page: routePage,
    sortOrder: routeSortOrder,
    sortBy: routeSortBy,
  } = queryParams;

  const [page, setPage] = useState(routePage ? Number(routePage) : 1);
  const [sortOrder, setSortOrder] = useState(
    routeSortOrder || initialSortOrder,
  );
  const [sortBy, setSortBy] = useState(routeSortBy || initialSortBy);

  const handlePageChange = (_e, value) => setPage(value);

  const handleSortChange = (sortField, newSortOrder) => {
    setSortBy(sortField);
    setSortOrder(newSortOrder);
  };

  return {
    page,
    sortBy,
    sortOrder,
    handlePageChange,
    handleSortChange,
    setPage,
    setQueryParams,
  };
};

export default useTableState;
